/**
 * @generated SignedSource<<8ceba97addc680eea23e3fde13212dc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueSidebarSecondary$data = {
  readonly repository: {
    readonly viewerCanPush: boolean;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AssigneesSectionLazyFragment" | "OptionsSectionSecondary">;
  readonly " $fragmentType": "IssueSidebarSecondary";
};
export type IssueSidebarSecondary$key = {
  readonly " $data"?: IssueSidebarSecondary$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueSidebarSecondary">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueSidebarSecondary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanPush",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OptionsSectionSecondary"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssigneesSectionLazyFragment"
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "0c2d2f1dd0ee8f4b66648faa84025b82";

export default node;
